/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */
import React, { Fragment, useEffect, useState } from 'react';
import {
  Row,
  Col,
  Card,
  CardTitle,
  CardBody,
  Button,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  NavItem,
  Nav,
  TabContent,
  TabPane,
  Label,
  NavLink,
} from 'reactstrap';
// import { NavLink } from 'react-router-dom';
import {
  Separator,
  Colxx,
} from '../../../../components/common/CustomBootstrap';
import DocumentForm from './Components/externalSourcesForm';
import { AxiosAPI, getUserID, getGroupID } from '../../../../helpers/AxiosAPI';
import {
  API_External_Source,
  API_Ingetration_Channels,
  gAPI_Internal_Property_By_Id,
  API_Rezdy_Integration_Item,
  API_WAYS_Integration_Item,
} from '../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Logs from './Components/Logs';
import Validation from '../../../../components/Validation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDotCircle } from '@fortawesome/free-solid-svg-icons';
import no_webpages from './../../../../assets/web_pages.png';
import sync_website from '../../../../assets/website_to_bot.png';
import { NotificationManager } from '../../../../components/common/react-notifications';
import ExternalSourcesList from './Components/externalSourcesList';
import ExternalSourcesForm from './Components/externalSourcesForm';
import classnames from 'classnames';
import SynxisForm from './Components/synxisForm';
import FarehourborForm from './Components/farehourborForm';
import IntlMessages from '../../../../helpers/IntlMessages';
import RezdyForm from './Components/RezdyForm';
import WaysForm from './Components/WaysForm';
import RMSForm from './Components/RMSForm';
import NewbookForm from './Components/NewbookForm';
const style_css = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
    top:auto !important;
    bottom: 0 !important;
  }
  .active{
    background-color:transparent;
  }`;

const sortOptions = [
  { text: 'Date Newest to Oldest', value: 'Date:DESC', label: 'Date DESC' },
  { text: 'Date Oldest to Newest', value: 'Date:ASC', label: 'Date ASC' },
  { text: 'Title A to Z', value: 'Title:ASC', label: 'Title ASC' },
  { text: 'Title Z to A', value: 'Title:DESC', label: 'Title DESC' },
];

const ExternalSources = ({ propertyId }) => {
  const [sortType, setSortType] = useState('Title:ASC');
  const [sabreIntegration, setSabreIntegration] = useState();
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [createExternalResource, setCreateDocument] = useState(false);
  const [showLogs, setShowLogs] = useState(false);
  const [tags, setTags] = useState([]);
  const [externalSourceList, setExternalSourceList] = useState([]);
  const [activeTab, setActiveTab] = useState('WebPage');
  const [synxisData, setSynxisData] = useState(null);
  const [farehourborData, setFarehourborData] = useState(null);
  const [farehourborIntegrationList, setFarehourborIntegrationList] = useState(
    []
  );
  const [rezdyData, setRezdyData] = useState(null);
  const [rezdyIntegrationList, setRezdyIntegrationList] = useState([]);
  const [waysData, setWaysData] = useState(null);
  const [rmsData, setRMSData] = useState(null);
  const [waysIntegrationList, setWaysIntegrationList] = useState([]);
  const [propertyLanguages, setPropertyLanguages] = useState(['en']);
  const [categories, setCategories] = useState([]);
  const [categoriesWays, setCategoriesWays] = useState([]);
  const [rmsIntegrationList, setRMSIntegrationList] = useState([]);
  const [hotelCode, setHotelCode] = useState(''); 
  const [newbookData, setNewbookData] = useState(null);
  const [newbookIntegrationList, setNewbookIntegrationList] = useState([]);

  const handleToggle = () => {
    setCreateDocument(!createExternalResource);
  };
  useEffect(() => {
    let body = {
      channels: ['Sabre', 'Farehourbor', 'Rezdy', 'Ways', 'RMSBookingEngine', 'NewbookBookingEngine'],
    };
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
    }).then((json) => {
      if (json.data?.languages && json.data.languages.length > 0) {
        setPropertyLanguages(json.data.languages);
      }
      if (json.data?.providerPropertyId) {
        setHotelCode(json?.data?.providerPropertyId || '');
      }
      AxiosAPI({
        method: 'post',
        url: `${API_Ingetration_Channels}?group_id=${getGroupID()}`,
        data: body,
      }).then((res) => {
        // console.log(res.data);
        const sabreIntegrations = res.data.filter(
          (k) =>
            k.channel === 'Sabre' &&
            k.disabled === false &&
            k.properties.includes(propertyId)
        );
        setSabreIntegration(
          sabreIntegrations.length > 0 ? sabreIntegrations[0] : undefined
        );

        setFarehourborIntegrationList(
          res.data.filter(
            (k) =>
              k.channel === 'Farehourbor' &&
              k.disabled === false &&
              k.properties.includes(propertyId)
          )
        );
        var rezdyInt = res.data.filter(
          (k) =>
            k.channel === 'Rezdy' &&
            k.disabled === false &&
            k.properties.includes(propertyId)
        );
        if (rezdyInt.length > 0) {
          LoadRezdyCategory(rezdyInt);
          setRezdyIntegrationList(rezdyInt);
        }
        var waysInt = res.data.filter(
          (k) =>
            k.channel === 'Ways' &&
            k.disabled === false &&
            k.properties.includes(propertyId)
        );
        if (waysInt.length > 0) {
          LoadWaysCategory(waysInt);
          setWaysIntegrationList(waysInt);
        }
        var rmsInt = res.data.filter(
          (k) =>
            k.channel === 'RMSBookingEngine' &&
            k.disabled === false &&
            k.properties.includes(propertyId)
        );
        console.log(rmsInt, 157);
        if (rmsInt.length > 0) {
          setRMSIntegrationList(rmsInt);
        }
        var newbookInt = res.data.filter(
          (k) =>
            k.channel === 'NewbookBookingEngine' &&
            k.disabled === false &&
            k.properties.includes(propertyId)
        );
        if (newbookInt.length > 0) {
          setNewbookIntegrationList(newbookInt);
        }
      });
    });
  }, [propertyId]);

  useEffect(() => {
    LoadData();
  }, [propertyId, sortType]);

  // useEffect(() => {
  //   if (rezdyIntegrationList !== null && rezdyIntegrationList.length > 0 && activeTab === "Rezdy") {
  //     console.log(159, rezdyIntegrationList);
  //     LoadRezdyCategory();
  //   }
  // }, [rezdyIntegrationList, activeTab]);
  const LoadData = () => {
    AxiosAPI({
      method: 'get',
      url: `${API_External_Source}?groupId=${getGroupID()}&propertyId=${propertyId}`,
    }).then((res) => {
      const data = res.data;
      const synxisItem = data.find((item) => item.sourceType === 'SynXis');

      if (synxisItem) {
        setSynxisData(synxisItem);
      }
      const filteredData = data.filter((item) => item.sourceType === 'WebPage');
      setExternalSourceList(filteredData);
      setFarehourborData(
        data.find((item) => item.sourceType === 'Farehourbor')
      );
      setRezdyData(data.find((item) => item.sourceType === 'Rezdy'));
      setWaysData(data.find((item) => item.sourceType === 'Ways'));
      setRMSData(data.find((item) => item.sourceType === 'RMS'));
      setNewbookData(data.find((item) => item.sourceType === 'Newbook'));
    });
  };
  const LoadRezdyCategory = (rezdyInt) => {
    AxiosAPI({
      method: 'get',
      url: `${API_Rezdy_Integration_Item}/${
        rezdyInt[0]?.id
      }?group_id=${getGroupID()}`,
    }).then((rescategory) => {
      var category = [];
      rescategory.data.map((m) =>
        AxiosAPI({
          method: 'get',
          url: `${API_Rezdy_Integration_Item}/${
            rezdyInt[0]?.id
          }/products-by-category?group_id=${getGroupID()}&category_id=${m.id}`,
        }).then((res) => {
          var products = [
            { label: 'All (Current & New)', key: 'all', value: 'all' },
          ];
          res.data.map((k) =>
            products.push({
              label: k.name,
              key: k.productCode,
              value: k.productCode,
            })
          );
          category.push({
            label: m.name,
            key: m.id,
            value: m.id,
            products: products,
          });
        })
      );
      setCategories(category);
    });
  };
  const LoadWaysCategory = (waysInt) => {
    AxiosAPI({
      method: 'get',
      url: `${API_WAYS_Integration_Item}/${
        waysInt[0]?.id
      }?group_id=${getGroupID()}`,
    }).then((rescategory) => {
      var category = [];

      if (rescategory.data.length > 0) {
        rescategory.data.map((l) => {
          AxiosAPI({
            method: 'get',
            url: `${API_WAYS_Integration_Item}/${
              waysInt[0]?.id
            }/products?group_id=${getGroupID()}&category_id=${l.id}`,
          }).then((res) => {
            var filteredprod = res.data;
            var products = [
              { label: 'All (Current & New)', key: 'all', value: 'all' },
            ];
            filteredprod.map((x) => {
              if (x.slug === null) {
                products.push({
                  label: x.title,
                  key: x.resourceGroupCollectionId,
                  value: x.resourceGroupCollectionId,
                });
              } else {
                products.push({ label: x.title, key: x.slug, value: x.slug });
              }
            });
            category.push({ label: l.name, value: l.id, products: products });
          });
        });

        setCategoriesWays(category);
      }
    });
  };
  const handleAddDocument = (inputData) => {
    AxiosAPI({
      method: 'post',
      url: API_External_Source,
      data: inputData,
    }).then((res) => {
      if (
        res.data.HttpStatusCode !== undefined &&
        res.data.HttpStatusCode === 400 &&
        res.data.Messages !== undefined &&
        res.data.Messages !== null &&
        res.data.Messages.length > 0
      ) {
        setMsg(res.data.Messages);
        setOpen(true);
      } else {
        setCreateDocument(false);
        LoadData();
      }
    });
  };

  const toggleAppMenu = (tab) => {
    setActiveTab(tab);
  };

  const handleShowLogs = () => {
    setShowLogs(!showLogs);
  };

  return (
    <Fragment>
      <Row>
        <Colxx xxs="12">
          <div className="mb-4">
            <h4>
              <b>
                <IntlMessages id="dashboards.sprint-title" />
              </b>
            </h4>
            <p>
              {' '}
              <IntlMessages id="dashboards.sprint-description" />
            </p>
          </div>
          <div className="info-set-background theme-color-orange d-flex align-items-center">
            <div className=" p-2">
              <svg
                fill="#f71d1d"
                version="1.1"
                id="Capa_1"
                viewBox="0 0 123.996 123.996"
                width="20"
                height="20"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <g>
                    <path d="M9.821,118.048h104.4c7.3,0,12-7.7,8.7-14.2l-52.2-92.5c-3.601-7.199-13.9-7.199-17.5,0l-52.2,92.5 C-2.179,110.348,2.521,118.048,9.821,118.048z M70.222,96.548c0,4.8-3.5,8.5-8.5,8.5s-8.5-3.7-8.5-8.5v-0.2c0-4.8,3.5-8.5,8.5-8.5 s8.5,3.7,8.5,8.5V96.548z M57.121,34.048h9.801c2.699,0,4.3,2.3,4,5.2l-4.301,37.6c-0.3,2.7-2.1,4.4-4.6,4.4s-4.3-1.7-4.6-4.4 l-4.301-37.6C52.821,36.348,54.422,34.048,57.121,34.048z"></path>
                  </g>
                </g>
              </svg>
            </div>
            <div className=" col-11 col-xs-11 p-2">
              <span className="text-warning ">
                {' '}
                <IntlMessages id="dashboards.sprint-feature" />
                {/* The Sprint feature is designed to sync knowledge from external
                sources, making it valuable for both initial setup and ongoing
                data updates. When executed on an active system, Sprint modifies
                the Knowledge Hub based on your configured external sources,
                which can directly influence AI-generated behaviors and
                responses. For assistance with Sprint setup, please contact our
                support team. */}
                {/* The Sprint feature is primarily designed for initial system setup. Executing Sprint on an active system may modify the knowledge hub data, potentially altering AI-generated behaviors and responses. Please {' '}
                    <a
                      href="https://help.myma.ai/en/"
                      style={{ textDecoration: 'underline' }}
                      target='_blank'
                    >
                      contact our support team
                    </a>
                    {' '} to discuss potential impacts and ensure optimal system performance. */}
              </span>
            </div>
          </div>
          <Nav tabs className="card-header-tabs separator-tabs mb-3 ml-2 mr-0">
            <style>{style_css}</style>
            <NavItem
              className="text-center"
              style={{ width: 'auto', background: '' }}
            >
              <NavLink
                style={{ background: 'none', cursor: 'pointer' }}
                className={classnames({
                  active: activeTab === 'WebPage',
                  'nav-link': true,
                })}
                onClick={() => {
                  toggleAppMenu('WebPage');
                }}
                to="#"
              >
                <span
                  style={{
                    color: `${
                      activeTab === 'WebPage' ? 'var(--theme-color-1)' : 'black'
                    }`,
                  }}
                >
                  <IntlMessages id="dashboards.web-pages" />
                </span>
              </NavLink>
            </NavItem>
            {sabreIntegration !== undefined && (
              <NavItem
                className="text-center"
                style={{ width: 'auto', background: '' }}
              >
                <NavLink
                  style={{ background: 'none', cursor: 'pointer' }}
                  className={classnames({
                    active: activeTab === 'SynXis',
                    'nav-link': true,
                  })}
                  onClick={() => {
                    toggleAppMenu('SynXis');
                  }}
                  to="#"
                >
                  <span
                    style={{
                      color: `${
                        activeTab === 'SynXis'
                          ? 'var(--theme-color-1)'
                          : 'black'
                      }`,
                    }}
                  >
                    SynXis
                  </span>
                </NavLink>
              </NavItem>
            )}
            {farehourborIntegrationList &&
              farehourborIntegrationList.length > 0 && (
                <NavItem
                  className="text-center"
                  style={{ width: 'auto', background: '' }}
                >
                  <NavLink
                    style={{ background: 'none', cursor: 'pointer' }}
                    className={classnames({
                      active: activeTab === 'Farehourbor',
                      'nav-link': true,
                    })}
                    onClick={() => {
                      toggleAppMenu('Farehourbor');
                    }}
                    to="#"
                  >
                    <span
                      style={{
                        color: `${
                          activeTab === 'Farehourbor'
                            ? 'var(--theme-color-1)'
                            : 'black'
                        }`,
                      }}
                    >
                      FareHarbor
                    </span>
                  </NavLink>
                </NavItem>
              )}
            {rezdyIntegrationList && rezdyIntegrationList.length > 0 && (
              <NavItem
                className="text-center"
                style={{ width: 'auto', background: '' }}
              >
                <NavLink
                  style={{ background: 'none', cursor: 'pointer' }}
                  className={classnames({
                    active: activeTab === 'Rezdy',
                    'nav-link': true,
                  })}
                  onClick={() => {
                    toggleAppMenu('Rezdy');
                  }}
                  to="#"
                >
                  <span
                    style={{
                      color: `${
                        activeTab === 'Rezdy' ? 'var(--theme-color-1)' : 'black'
                      }`,
                    }}
                  >
                    Rezdy
                  </span>
                </NavLink>
              </NavItem>
            )}
            {waysIntegrationList && waysIntegrationList.length > 0 && (
              <NavItem
                className="text-center"
                style={{ width: 'auto', background: '' }}
              >
                <NavLink
                  style={{ background: 'none', cursor: 'pointer' }}
                  className={classnames({
                    active: activeTab === 'Ways',
                    'nav-link': true,
                  })}
                  onClick={() => {
                    toggleAppMenu('Ways');
                  }}
                  to="#"
                >
                  <span
                    style={{
                      color: `${
                        activeTab === 'Ways' ? 'var(--theme-color-1)' : 'black'
                      }`,
                    }}
                  >
                    Way
                  </span>
                </NavLink>
              </NavItem>
            )}
            {rmsIntegrationList && rmsIntegrationList.length > 0 && (
              <NavItem
                className="text-center"
                style={{ width: 'auto', background: '' }}
              >
                <NavLink
                  style={{ background: 'none', cursor: 'pointer' }}
                  className={classnames({
                    active: activeTab === 'Ways',
                    'nav-link': true,
                  })}
                  onClick={() => {
                    toggleAppMenu('RMSBookingEngine');
                  }}
                  to="#"
                >
                  <span
                    style={{
                      color: `${
                        activeTab === 'RMSBookingEngine'
                          ? 'var(--theme-color-1)'
                          : 'black'
                      }`,
                    }}
                  >
                    RMS
                  </span>
                </NavLink>
              </NavItem>
            )}
            {newbookIntegrationList && newbookIntegrationList.length > 0 && (
              <NavItem
                className="text-center"
                style={{ width: 'auto', background: '' }}
              >
                <NavLink
                  style={{ background: 'none', cursor: 'pointer' }}
                  className={classnames({
                    active: activeTab === 'NewbookBookingEngine',
                    'nav-link': true,
                  })}
                  onClick={() => {
                    toggleAppMenu('NewbookBookingEngine');
                  }}
                  to="#"
                >
                  <span
                    style={{
                      color: `${activeTab === 'NewbookBookingEngine'
                        ? 'var(--theme-color-1)'
                        : 'black'
                        }`,
                    }}
                  >
                    Newbook
                  </span>
                </NavLink>
              </NavItem>
            )}
          </Nav>

          <TabContent activeTab={activeTab} className="">
            <TabPane tabId="WebPage" className="chat-app-tab-pane">
              <Row>
                <Colxx xxs="12" className="mb-0">
                  <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                    <DropdownToggle caret color="outline-dark" size="xs">
                      <IntlMessages id="dashboards.order-by" />
                      {sortOptions.filter((f) => f.value === sortType).length >
                      0
                        ? ': ' +
                          sortOptions.filter((f) => f.value === sortType)[0]
                            .label
                        : ''}
                    </DropdownToggle>
                    <DropdownMenu>
                      {sortOptions.map((order, index) => {
                        return (
                          <DropdownItem
                            key={index}
                            onClick={() => setSortType(order.value)}
                          >
                            {order.text}
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                  <Button
                    size="xs"
                    outline
                    className=""
                    onClick={handleToggle}
                    color="primary"
                  >
                    {' '}
                    + <IntlMessages id="dashboards.add-web-page" />
                  </Button>
                  {/* <Button
            size="xs"
            outline
            className="ml-2"
            color="primary"
            onClick={handleShowLogs}
          >
            Change Log
          </Button> */}
                </Colxx>
              </Row>
              <Row className="mb-2">
                <Col md="12" className="mt-2 ">
                  <img
                    src={sync_website}
                    // style={{ width: '100%', height: '90px' }}
                  ></img>
                </Col>
              </Row>
              <Colxx xxs="12" className="mb-2 text-right">
                <strong>
                  <hr />
                </strong>
              </Colxx>
              <Row className="mb-3">
                {externalSourceList !== undefined &&
                externalSourceList.length > 0 ? (
                  <Colxx xxs="12" className="mb-4">
                    <ExternalSourcesList
                      tags={tags}
                      LoadData={LoadData}
                      sabreIntegration={sabreIntegration}
                      externalSourceList={externalSourceList}
                    ></ExternalSourcesList>
                  </Colxx>
                ) : (
                  <Fragment>
                    <Colxx xxs="12" className="text-center">
                      <img
                        className="w-25"
                        style={{ marginTop: '5rem' }}
                        src={no_webpages}
                      ></img>
                    </Colxx>
                    <Colxx xxs="12" className="mb-4 text-center">
                      <Button
                        color="primary"
                        size="sm"
                        className="top-right-button mt-2 mr-1"
                        onClick={handleToggle}
                      >
                        + <IntlMessages id="dashboards.addFirstWebPage" />
                      </Button>
                    </Colxx>
                  </Fragment>
                )}
              </Row>
            </TabPane>
            {sabreIntegration !== undefined && (
              <TabPane tabId="SynXis" className="chat-app-tab-pane">
                <Row className="mt-3 mb-2">
                  <SynxisForm
                    submit={handleAddDocument}
                    LoadData={LoadData}
                    hotelCode={hotelCode}
                    propertyLanguages={[...propertyLanguages]}
                    synxisData={synxisData}
                    sabreIntegration={sabreIntegration}
                  />
                </Row>
              </TabPane>
            )}
            {activeTab === 'Farehourbor' &&
              farehourborIntegrationList &&
              farehourborIntegrationList.length > 0 && (
                <TabPane tabId="Farehourbor" className="chat-app-tab-pane">
                  <Row className="mt-3 mb-2">
                    <FarehourborForm
                      submit={handleAddDocument}
                      LoadData={LoadData}
                      farehourborData={farehourborData}
                      farehourborIntegration={farehourborIntegrationList[0]}
                    />
                  </Row>
                </TabPane>
              )}
            {activeTab === 'Rezdy' &&
              rezdyIntegrationList &&
              rezdyIntegrationList.length > 0 && (
                <TabPane tabId="Rezdy" className="chat-app-tab-pane">
                  <Row className="mt-3 mb-2">
                    <RezdyForm
                      submit={handleAddDocument}
                      LoadData={LoadData}
                      rezdyData={rezdyData}
                      rezdyIntegration={rezdyIntegrationList[0]}
                      categoriesItems={categories}
                    />
                  </Row>
                </TabPane>
              )}
            {activeTab === 'Ways' &&
              waysIntegrationList &&
              waysIntegrationList.length > 0 && (
                <TabPane tabId="Ways" className="chat-app-tab-pane">
                  <Row className="mt-3 mb-2">
                    <WaysForm
                      submit={handleAddDocument}
                      LoadData={LoadData}
                      waysData={waysData}
                      waysIntegration={waysIntegrationList[0]}
                      categoriesItems={categoriesWays}
                    />
                  </Row>
                </TabPane>
              )}
            {activeTab === 'RMSBookingEngine' &&
              rmsIntegrationList &&
              rmsIntegrationList.length > 0 && (
                <TabPane tabId="RMSBookingEngine" className="chat-app-tab-pane">
                  <Row className="mt-3 mb-2">
                    <RMSForm
                      submit={handleAddDocument}
                      LoadData={LoadData}
                      rmsData={rmsData}
                      rmsIntegration={rmsIntegrationList[0]}
                    />
                  </Row>
                </TabPane>
              )}
            {activeTab === 'NewbookBookingEngine' &&
              newbookIntegrationList &&
              newbookIntegrationList.length > 0 && (
                <TabPane tabId="NewbookBookingEngine" className="chat-app-tab-pane">
                  <Row className="mt-3 mb-2">
                    <NewbookForm
                      submit={handleAddDocument}
                      LoadData={LoadData}
                      newbookData={newbookData}
                      newbookIntegration={newbookIntegrationList[0]}
                    />
                  </Row>
                </TabPane>
              )}
          </TabContent>
        </Colxx>
      </Row>
      {createExternalResource && (
        <ExternalSourcesForm
          taglist={tags}
          sabreIntegration={sabreIntegration}
          label={'External Source'}
          LoadData={LoadData}
          toggle={handleToggle}
          submit={handleAddDocument}
          visible={createExternalResource}
        ></ExternalSourcesForm>
      )}

      {showLogs && (
        <Logs
          label={'Document Logs'}
          toggle={handleShowLogs}
          visible={showLogs}
          logType="Document"
        ></Logs>
      )}

      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
};

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, email } = settings;
  return {
    propertyId,
    locale,
    email,
  };
};

export default injectIntl(connect(mapStateToProps, {})(ExternalSources));
